function assert<T>(condition: T, msg = 'Assertion failed'): asserts condition {
    if (!condition) {
        throw new Error(msg);
    }
}

export default assert;
